import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import SiteFooter from './common/SiteFooter';

/**
 * A/S 무료보철제작 신청 랜딩 (/as) — 비회원, 가입 없음
 * 치과가 30초 만에 신청 → 관리자가 확인 전화 → 기공소 수동 매칭 (컨시어지)
 */
const REGIONS = ['서울', '경기', '인천', '부산', '대구', '광주', '대전', '울산', '세종', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주'];
const TYPES = ['크라운', '브릿지', '인레이/온레이', '라미네이트', '임플란트 보철', '덴처(틀니)', '기타'];

const C = {
    ink: '#151b26', sub: '#5b6472', faint: '#8b93a1', hair: '#e6e8ec', bg: '#f5f6f8',
    accent: '#274690', accentSoft: '#eef1f8', ok: '#157f3d', okSoft: '#e9f5ee',
};
const inputStyle = { width: '100%', padding: '13px 14px', border: `1px solid #d3d7de`, borderRadius: 9, fontSize: 15, boxSizing: 'border-box', fontFamily: 'inherit', color: C.ink, background: '#fff' };
const labelStyle = { display: 'block', fontSize: 13, fontWeight: 700, marginBottom: 7, color: '#374151' };

function AsLanding() {
    const [form, setForm] = useState({ clinicName: '', contactName: '', phone: '', region: '', prosthesisType: '', notes: '' });
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

    // 검색엔진 비노출 (법무 판정 2026-08-06) — /as 페이지만 noindex, 언마운트 시 제거
    useEffect(() => {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex';
        document.head.appendChild(meta);
        return () => { document.head.removeChild(meta); };
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        if (!form.clinicName.trim()) { alert('치과명을 입력해주세요.'); return; }
        if (!/^01[016789][0-9-]{7,10}$/.test(form.phone.replace(/\s/g, ''))) { alert('올바른 휴대폰 번호를 입력해주세요.'); return; }
        if (!form.prosthesisType) { alert('보철 종류를 선택해주세요.'); return; }
        setSubmitting(true);
        try {
            const fn = httpsCallable(getFunctions(undefined, 'asia-northeast3'), 'submitAsLead');
            await fn(form);
            setDone(true);
            window.scrollTo(0, 0);
        } catch (err) {
            alert(err.message || '접수에 실패했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            setSubmitting(false);
        }
    };

    const Step = ({ n, title, desc }) => (
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <div style={{ width: 30, height: 30, borderRadius: '50%', border: `1.5px solid ${C.accent}`, color: C.accent, fontWeight: 800, fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#fff' }}>{n}</div>
            <div>
                <div style={{ fontSize: 14.5, fontWeight: 700, color: C.ink }}>{title}</div>
                <div style={{ fontSize: 12.5, color: C.sub, marginTop: 2, lineHeight: 1.6 }}>{desc}</div>
            </div>
        </div>
    );

    if (done) {
        return (
            <div style={{ minHeight: '100vh', background: C.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Pretendard", "Apple SD Gothic Neo", "Malgun Gothic", sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
                <div style={{ maxWidth: 440, width: '100%', background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 16, padding: '40px 32px', textAlign: 'center' }}>
                    <div style={{ width: 56, height: 56, borderRadius: '50%', background: C.okSoft, color: C.ok, fontSize: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>✓</div>
                    <h2 style={{ fontSize: 21, fontWeight: 800, color: C.ink, letterSpacing: '-0.5px' }}>접수되었습니다</h2>
                    <p style={{ fontSize: 14, color: C.sub, lineHeight: 1.7, marginTop: 12 }}>
                        영업일 기준 <b>하루 안에</b> 담당자가 전화드립니다.<br />
                        케이스 확인 후 가장 잘 맞는 기공소를 배정해드립니다.
                    </p>
                    <div style={{ marginTop: 22, padding: '13px 16px', background: C.bg, borderRadius: 10, fontSize: 12.5, color: C.sub, lineHeight: 1.7 }}>
                        급하신 경우 담당자에게 바로 전화해주세요<br />
                        <a href="tel:01029723733" style={{ color: C.accent, fontWeight: 700, fontSize: 15 }}>010-2972-3733</a>
                    </div>
                    <button
                        onClick={() => {
                            setForm({ clinicName: '', contactName: '', phone: '', region: '', prosthesisType: '', notes: '' });
                            setDone(false);
                            window.scrollTo(0, 0);
                        }}
                        style={{ width: '100%', marginTop: 18, background: C.accent, color: '#fff', border: 'none', borderRadius: 10, padding: '14px', fontSize: 15, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit' }}>
                        확인 — 처음 화면으로
                    </button>
                    <a href="/find-lab"
                        style={{ display: 'block', textAlign: 'center', marginTop: 10, background: '#fff', color: C.accent, border: `1.5px solid ${C.accent}`, borderRadius: 10, padding: '13px', fontSize: 14, fontWeight: 800, textDecoration: 'none', fontFamily: 'inherit' }}>
                        🔍 기다리는 동안 기공소 둘러보기
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', background: C.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Pretendard", "Apple SD Gothic Neo", "Malgun Gothic", sans-serif' }}>
            {/* 상단 바 */}
            <div style={{ background: '#fff', borderBottom: `1px solid ${C.hair}` }}>
                <div style={{ maxWidth: 920, margin: '0 auto', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 28, height: 28, borderRadius: 7, background: C.accent, color: '#fff', fontSize: 11, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>DC</div>
                    <b style={{ fontSize: 15, color: C.ink, letterSpacing: '-0.3px' }}>덴탈클러스터</b>
                    <span style={{ marginLeft: 'auto', fontSize: 12, color: C.faint }}>치과 · 기공소 거래 플랫폼</span>
                </div>
            </div>

            <div style={{ maxWidth: 920, margin: '0 auto', padding: '40px 20px 80px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 36, alignItems: 'start' }}>
                {/* 좌: 소개 */}
                <div>
                    <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 2, color: C.accent }}>치과 원장님께 · 가입 없음</div>
                    <h1 style={{ fontSize: 32, fontWeight: 800, color: C.ink, letterSpacing: '-1px', lineHeight: 1.3, marginTop: 10 }}>
                        잘못 나온 보철,<br />재제작 상담을 도와드립니다
                    </h1>
                    <p style={{ fontSize: 15, color: C.sub, lineHeight: 1.75, marginTop: 14, maxWidth: 420 }}>
                        기존 기공소에서 만든 보철의 A/S가 필요하신가요?
                        등록 기공소가 <b>재제작 상담</b>을 도와드립니다.
                        기공소에게는 실력을 보여드릴 기회라, 어느 케이스보다 정성껏 만듭니다.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 18, marginTop: 30 }}>
                        <Step n="1" title="30초 신청" desc="아래 폼만 남겨주세요. 회원가입·앱 설치가 없습니다." />
                        <Step n="2" title="확인 전화" desc="영업일 기준 하루 안에 담당자가 케이스를 확인합니다." />
                        <Step n="3" title="기공소 배정" desc="지역·전문분야가 맞는 기공소를 배정해 직접 연락드리게 합니다." />
                    </div>

                    <div style={{ marginTop: 30, padding: '14px 18px', background: '#fff', border: `1px solid ${C.hair}`, borderLeft: `3px solid ${C.accent}`, borderRadius: 10, fontSize: 12.5, color: C.sub, lineHeight: 1.7 }}>
                        <b style={{ color: C.ink }}>비용 안내</b><br />
                        치과에 별도 이용료를 청구하지 않습니다. 재제작 상담과 기공소 매칭에 드는 비용은
                        참여 기공소가 부담합니다. 재제작 이후 거래를 이어갈지는 원장님이 결정하시면 됩니다.
                    </div>
                </div>

                {/* 우: 신청 폼 */}
                <form onSubmit={submit} style={{ background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 16, padding: '28px 26px', boxShadow: '0 10px 30px rgba(21,27,38,.06)' }}>
                    <h2 style={{ fontSize: 18, fontWeight: 800, color: C.ink, letterSpacing: '-0.4px', marginBottom: 20 }}>A/S 재제작 상담 신청</h2>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                        <div>
                            <label style={labelStyle}>치과명 *</label>
                            <input style={inputStyle} value={form.clinicName} onChange={set('clinicName')} placeholder="예: OO치과의원" />
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                            <div>
                                <label style={labelStyle}>담당자 (선택)</label>
                                <input style={inputStyle} value={form.contactName} onChange={set('contactName')} placeholder="성함 또는 직함" />
                            </div>
                            <div>
                                <label style={labelStyle}>지역</label>
                                <select style={inputStyle} value={form.region} onChange={set('region')}>
                                    <option value="">선택</option>
                                    {REGIONS.map(r => <option key={r}>{r}</option>)}
                                </select>
                            </div>
                        </div>
                        <div>
                            <label style={labelStyle}>휴대폰 번호 *</label>
                            <input style={inputStyle} value={form.phone} onChange={set('phone')} placeholder="010-0000-0000" inputMode="tel" />
                            <div style={{ fontSize: 11.5, color: C.faint, marginTop: 5 }}>확인 전화와 기공소 배정 안내에만 사용됩니다.</div>
                        </div>
                        <div>
                            <label style={labelStyle}>보철 종류 *</label>
                            <select style={inputStyle} value={form.prosthesisType} onChange={set('prosthesisType')}>
                                <option value="">선택하세요</option>
                                {TYPES.map(t => <option key={t}>{t}</option>)}
                            </select>
                        </div>
                        <div>
                            <label style={labelStyle}>케이스 설명 (선택)</label>
                            <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 84 }} value={form.notes} onChange={set('notes')}
                                placeholder="예: 지르코니아 크라운 변연이 맞지 않아 재제작이 필요합니다. 급한 건입니다." />
                            <div style={{ fontSize: 11.5, color: C.faint, marginTop: 5 }}>사진은 담당자 확인 전화 때 문자로 보내주시면 됩니다.</div>
                        </div>
                        <button type="submit" disabled={submitting}
                            style={{ background: submitting ? '#8fa3cf' : C.accent, color: '#fff', border: 'none', borderRadius: 10, padding: '15px', fontSize: 15.5, fontWeight: 800, cursor: submitting ? 'default' : 'pointer', fontFamily: 'inherit', letterSpacing: '-0.2px' }}>
                            {submitting ? '접수 중…' : '상담 신청하기'}
                        </button>
                        <div style={{ fontSize: 11, color: C.faint, textAlign: 'center', lineHeight: 1.6 }}>
                            신청 시 연락처가 기공소 배정 목적에 한해 이용됩니다.<br />
                            문의: <a href="tel:01029723733" style={{ color: C.accent, fontWeight: 700 }}>010-2972-3733</a>
                            {' · '}<a href="https://pf.kakao.com/_xfsREX" target="_blank" rel="noopener noreferrer" style={{ color: C.accent, fontWeight: 700 }}>카카오톡 채널</a>
                        </div>
                        <a href="/find-lab"
                            style={{ display: 'block', textAlign: 'center', background: '#fff', color: C.accent, border: `1.5px solid ${C.accent}`, borderRadius: 10, padding: '13px', fontSize: 14.5, fontWeight: 800, textDecoration: 'none', fontFamily: 'inherit', letterSpacing: '-0.2px' }}>
                            🔍 기공소 둘러보기 — 등록 기공소 프로필 보기
                        </a>
                    </div>
                </form>
            </div>
            <SiteFooter />
        </div>
    );
}

export default AsLanding;
